import { RoomApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const roomSpaceMasterApi = {
  index: wrap(RoomApi, RoomApi.prototype.indexSpaceMaster),
};
